import axios from '@/utils/request'
import base from '../base'
import qs from 'qs'

export function jobList() {
    return axios.get(`${base.url}/quartz/quartz/list`);
}
export function addjobList(data) {
    return axios.post(`${base.url}/quartz/quartz/add`, qs.stringify(data));
}
export function triggerjobList(data) {
    return axios.post(`${base.url}/quartz/quartz/trigger`, qs.stringify(data));
}
export function deljobList(data) {
    return axios.post(`${base.url}/quartz/quartz/remove`, qs.stringify(data))
}
export function stopjobList(data) {
    return axios.post(`${base.url}/quartz/quartz/restoreToStop`, qs.stringify(data));
}

